import { BOARD_NODES } from '../game/board';

/** One projection for rendering, move paths, effects and hit targets. Pawns remain upright. */
export function projectBoardPoint(x: number, y: number) {
  const depth = (y - 80) / 440;
  return { x: 400 + (x - 300) * (1.03 + depth * .14), y: 113 + depth * 242 };
}
export const DISPLAY_NODES = BOARD_NODES.map(node => ({ ...node, ...projectBoardPoint(node.x, node.y) }));
